import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {BaseEffect} from './base.effect';
import {
  LoadMyCompaniesLinkContractAction, LoadMyCompaniesLinkContractFailAction,
  LoadMyCompaniesLinkContractSuccessAction,
  myCompaniesLinkContractActionTypes
} from '../actions/companies-link-contract';
import {CompaniesList} from '../../company/models/companies-list';
import {ArrayResponse, SendBackResult} from '..';
import {ContractLinkServiceService} from '../services/contract-link.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class CompaniesLinkContractEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(ofType(myCompaniesLinkContractActionTypes.LOAD),
    debug('Load companies list action received.'),
    map((action: LoadMyCompaniesLinkContractAction) => Object.assign({}, { $page: 1, $length: -1 , active: true , $orderBy: 'name' }, action.payload)),

    switchMap((filterD) => this.contractLinkServiceService.loadCompanies(filterD).pipe(
      map((payload: SendBackResult<ArrayResponse<CompaniesList>>) => new LoadMyCompaniesLinkContractSuccessAction(payload.data)),
      catchError(res => this.catchResponseError(res)))))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(myCompaniesLinkContractActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving companies list.'),
    map((action: LoadMyCompaniesLinkContractFailAction) => error(this.translation.translate('COMPANIES_LOAD_ERROR') + '  ' + action.payload,
      this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              router: Router,
              private contractLinkServiceService: ContractLinkServiceService) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadMyCompaniesLinkContractFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadMyCompaniesLinkContractFailAction(response['error'].message);
  }
}
